export enum ETicketLevel {
	NORMAL = "NORMAL",
	VPS = "VPS",
	SKYBOX = "SKYBOX"
}
